import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class BvFiltersConnectedFilterControlItem extends Component<{}> {
  @tracked focused = false;
}
